/* eslint-disable jsx-a11y/anchor-is-valid */
import { BaseSyntheticEvent, FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { Datatable } from '../../../../components/Datatable/Datatable'
import { Button } from '../../../../components/Button/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { Loading } from '../../../../components/Loading/Loading'
import Swal from 'sweetalert2'
import { GET, POST } from '../../../../services/api'
import { Input } from '../../../../components/Input/Input'
import { CSVLink } from 'react-csv'
import useAuth from '../../../../hooks/useAuth'
import { i18n } from '../../../../translate/i18n'
import { exportExcel } from '../../../../utils/utils'
import { BreadCrumbs } from '../../../../components/BreadCrumbs/breadCrumbrs'
import uuid from 'react-uuid'
type LogDownloadType = {
  Código: string
  Arquivo: string
  Status: string
}

type LogType = {
  code: string
  failureReason: string
  color: string
  file: string
}

type ImportationType = {
  id: number
  timeStart: string
  timeEnd: string
  totalProducts: number
  synchronizedProducts: number
  log: { errors: LogType[] }
  uploadImageFiles: UploadImageFiles[]
}
enum FileStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  RETRYING = 'RETRYING'  // ✅ ADICIONAR
}

type UploadImageFiles = {
  id: number;
  uploadImagesId: number;
  fileName: string;
  originalPath: string;
  tempPath: string | null;
  code: string;
  sku: string | null;
  resizeType: string;
  sizeImage: string;
  type: number;
  status: FileStatus;
  failureReason: string | null;
  metadata: {
    itemType: string;
    mimeType: string;
    repositoryType: string;
  };
  synchronized: boolean;
  workerId: number | null;
  processingStartedAt: string | null;
  completedAt: string | null;
  failedAt: string | null;
  retryCount: number;
  maxRetries: number;
  lastErrorMessage: string | null;
  nextRetryAt: string | null;
  createdAt: string;
  updatedAt: string;
};


const DetalhesImportacaoImagemContent: FC = () => {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const { id } = useParams()
  const [logs, setLogs] = useState<LogType[]>([])
  const [logsDownload, setLogsDownload] = useState<LogDownloadType[]>([])
  const [totalProducts, setTotalProducts] = useState(0)
  const [synchronizedProducts, setSynchronizedProducts] = useState(0)


  function alterColorByStatus(status: string): string {
    const opacity = '26'; // 15% opacity in hex
    switch (status) {
      case FileStatus.PENDING:
        return '#FFC107' + opacity
      case FileStatus.PROCESSING:
        return '#007BFF' + opacity
      case FileStatus.COMPLETED:
        return '#28A745' + opacity
      case FileStatus.FAILED:
        return '#DD4A25' + opacity
      case FileStatus.RETRYING:
        return '#6C757D' + opacity
      default:
        return '#6C757D' + opacity
    }
  }

  const getImportations = async () => {
    try {
      setLoading(true)
      const importationRes = await GET(`/upload-images-status/${id}`)
      if (importationRes && importationRes.data && importationRes.data.length) {
        const importation: ImportationType = importationRes.data[0]

        setTotalProducts(importation.totalProducts ? importation.totalProducts : 0)
        setSynchronizedProducts(
          importation.synchronizedProducts ? importation.synchronizedProducts : 0
        )
        if (importation.log && importation.log.errors) {
          setLogs(
            importation.log.errors && importation.log.errors.length > 0
              ? importation.log.errors.map((log) => ({
                id: uuid(),
                code: log.code,
                file: log.file,
                color: log.failureReason ? '#DD4A25' + '26' : '#28A745' + '26',
                failureReason: `
              <div style='margin: 0; display: flex; flex-direction: row; align-items: center'>
                <i class="fa fa-times" style='color: #DD4A25; margin-right: 10px'></i>
                ${log.failureReason}
              </div>`,
              }))
              : []
          )

          setLogsDownload(
            importation.log.errors && importation.log.errors.length > 0
              ? importation.log.errors.map((log) => ({
                Código: log.code,
                Arquivo: log.file,
                Status: log.failureReason,
              }))
              : []
          )
        } else if (importation.uploadImageFiles && importation.uploadImageFiles.length > 0) {
          setLogs(
            importation.uploadImageFiles.map((file) => ({
              id: uuid(),
              code: file.code,
              file: file.fileName,
              color: alterColorByStatus(file.status),
              failureReason: file.failureReason ? `
              <div style='margin: 0; display: flex; flex-direction: row; align-items: center'>
                <i class="fa fa-times" style='color: #DD4A25; margin-right: 10px'></i>
                ${file.failureReason ? file.failureReason : 'Erro desconhecido'}
              </div>` : file.status,
            }))
          )

          setLogsDownload(
            importation.uploadImageFiles.map((file) => ({
              Código: file.code,
              Arquivo: file.fileName,
              Status: file.failureReason ?? file.status,
            }))
          )

        } else {
          setLogs([])
          setLogsDownload([])
        }
      }
      setLoading(false)
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : '',
      }).then(() => navigate('/pluginconfig/others'))
    }
  }

  useEffect(() => {
    getImportations()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5 flex-row justify-content-space-between'>
              <div className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`imports.problem_title`)}
                  <BreadCrumbs />
                </span>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  <p className='mt-2 mb-0'>
                    {synchronizedProducts} {i18n.t(`imports.images_success`)}
                  </p>
                  <p className='mt-2 mb-0'>
                    {totalProducts - synchronizedProducts} {i18n.t(`imports.images_error`)}
                  </p>
                </span>
              </div>
              <div className='d-flex flex-row align-items-center gap-5'>
                <Button
                  text={i18n.t(`imports.download_problems`)}
                  color='primary'
                  iconColor='#FFF'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={async () => await exportExcel(logsDownload)}
                  btnClass='mt-4 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <div className='mt-4'>
                <Datatable
                  data={logs}
                  headers={[
                    { key: i18n.t(`imports.code`), value: 'code', type: 'default' },
                    {
                      key: i18n.t(`imports.file`),
                      value: 'file',
                      type: 'default',
                      noLimit: true,
                      size: 'w-50',
                    },
                    {
                      key: i18n.t(`imports.status`),
                      value: 'failureReason',
                      type: 'html',
                      size: 'w-50',
                    },
                  ]}
                  color='primary'
                  colorByRow
                />
              </div>
              <div>
                <Button
                  text={i18n.t(`buttons.back`)}
                  color='info'
                  iconColor='#FFF'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate(-1)}
                  btnClass='mt-4 fw-bolder'
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const DetalhesImportacaoImagem: FC = () => {
  const { loginInfo } = useAuth()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: true },
          {
            title: i18n.t(`imports.imports`),
            path:
              loginInfo.plugintype === 'varejo'
                ? 'product_varejo/prepare_import_image_product'
                : 'product_fashion/prepare_import_image_product',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`imports.problem_title`)}
      </PageTitle>
      <DetalhesImportacaoImagemContent />
    </>
  )
}

export { DetalhesImportacaoImagem }
